<template>
  <tbody v-if="fillManualFlag">
    <tr v-for="(item, index) in data" :key="index" :class="{ 'stock-request-valid-row': item.valid && item.status !== 200 }">
      <td class="stock-request-switch-icon" :class="item.loadRow ? '' : 'bg-white px-5/2'" :style="item.status === 200 ? 'background: #E7EEFB !important; pointer-events: none;': ''">
        <span>{{ index+1 }}</span>
        <feather-icon @click="deleteRow(index)" icon="Trash2Icon" svgClasses="w-5 h-5" class="self-center text-red"/>
      </td>
      <td>
        <template v-if="item.loadRow">
          <div class="stock-request-animated-input">
            <div class="line rounded-lg h-4"></div>
          </div>
        </template>
        <input v-else class="h-full" @paste.prevent="fillData($event, index, 'sku')" @input="item.valid = false" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''"
          v-model="item.sku" type="text" :class="(validateErrorContainError(item) && item.errors.error.sku) || (item.errors.sku) ? 'invalid-input' : ''">
      </td>
      <td>
        <template v-if="item.loadRow">
          <div class="stock-request-animated-input">
            <div class="line rounded-lg h-4"></div>
          </div>
        </template>
        <div v-else class="input-number h-full">
          <input class="text-center h-full" @paste.prevent="fillData($event, index, 'quantity')" @input="item.valid = false" :disabled="item.status === 200" :style="item.status === 200 ? 'background: #E7EEFB;': ''"
            v-validate="'numeric|min_value:1'" :name="`quantity-${index}`"
            v-model="item.quantity" type="number"
            :class="(validateErrorContainError(item) && item.errors.error.quantity) || item.errors.quantity || errors.has(`quantity-${index}`) ? 'invalid-input' : ''">
        </div>
      </td>
      <td>
        <template v-if="item.loadRow">
          <div class="stock-request-animated-input">
            <div class="line rounded-lg h-4"></div>
          </div>
        </template>
        <v-select v-else class="h-full stock-request-flag-select" :style="item.status === 200 ? 'background: #E7EEFB;pointer-events: none;': ''"
          v-model="item.flag" name="flags" :options="flags" label="name" multiple append-to-body
          :calculate-position="setFlagDropdownPosition" @input="item.valid = false"/>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { sendFulfillmentRequest } from '../../../../http/axios/requestHelper.js'
import i18nData from '../../../../i18n/i18nData'
import readXlsxFile from 'read-excel-file'
import common from '../../../../assets/utils/common.js'
import vSelect from 'vue-select'


export default {
  props: [
    'data', 'sendStockRequestFlag', 'uploadFileFlag', 'originFile', 'merchant', 'userMerchant',
    'fillManualFlag', 'deletedFile', 'fileDetails', 'rows', 'replacedFile', 'fillManualPressed', 'uploadType'
  ],
  data () {
    return {
      firstSend: true,
      isReplace: false,
      activeIndex: '',
      releaseVersion: process.env.VUE_APP_RELEASE_VERSION,
      fulfilmentCenter: '',
      allProductsList: [],
      productCatalog: [],
      searchInProgress: false,
      searchedValue: '',
      flags: [
        {
          id: 2,
          name: 'QC'
        },
        {
          id: 4,
          name: 'Fragile'
        }
      ]
    }
  },
  computed: {
    isStockRecall () {
      return this.uploadType === 'stock-recall'
    },
    productsQueryParams () {
      return this.isStockRecall ? '&current_inventory_level__gt=0' : ''
    },
    submitEndpoint () {
      return this.isStockRecall ? 'api/v1/fc/stock-recalls/' : 'api/v1/fc/stock-requests/'
    },
    quantityPayloadField () {
      return this.isStockRecall ? 'recall_quantity' : 'incoming_quantity'
    }
  },
  watch: {
    uploadFileFlag () {
      this.uploadFile(this.originFile)
    },
    deletedFile () {
      if (this.deletedFile !== '') this.removeItemsFromData()
    },
    sendStockRequestFlag (val) {
      if (val === true) {
        this.sendStockRequests()
      }
    }
  },
  methods: {
    emptyRow () {
      return {
        sku: '',
        quantity: '',
        flag: [],
        errors: {},
        fileName: '',
        fileUploadId: '',
        status: 0,
        loadRow: false,
        valid: false
      }
    },
    fillData (event, index, type) {
      const fullData = event.clipboardData.getData('text')
      const rawRows = fullData.split('\n')
      const pasteData = []
      let splitCols = {}
      rawRows.forEach((rawRow) => {
        const values = rawRow.split('\t')
        let [sku, quantity, flag] = ['', '', []]
        switch (type) {
        case 'sku':
          [sku, quantity, flag] = values
          splitCols = { sku, quantity, flag }
          break
        case 'quantity':
          [quantity, flag] = values
          splitCols = { quantity, flag }
          break
        default:
          splitCols = { [type]: values[0] }
        }
        pasteData.push(splitCols)
      })
      const extraRowsNumber = this.data.length < (pasteData.length + index + 1) ? (pasteData.length + index) - this.data.length : 0
      this.$emit('addExtraRows', extraRowsNumber)
      switch (type) {
      case 'sku':
        for (let i = 0; i < pasteData.length; i++) {
          this.data[index].sku = pasteData[i].sku
          if (pasteData[i].quantity) this.data[index].quantity = pasteData[i].quantity
          if (pasteData[i].flag) this.data[index].flag = this.getFlagsFromCell(pasteData[i].flag)
          this.data[index].valid = false
          index++
        }
        break
      case 'quantity':
        for (let i = 0; i < pasteData.length; i++) {
          this.data[index].quantity = pasteData[i].quantity
          if (pasteData[i].flag) this.data[index].flag = this.getFlagsFromCell(pasteData[i].flag)
          this.data[index].valid = false
          index++
        }
        break
      default:
        for (let i = 0; i < pasteData.length; i++) {
          this.data[index][type] = pasteData[i][type]
          this.data[index].valid = false
          index++
        }
        break
      }
    },
    deleteRow (rowIndex) {
      this.activeIndex = rowIndex
      this.$vs.dialog({
        color: 'danger',
        title: i18nData[this.$i18n.locale]['Confirm'],
        text: i18nData[this.$i18n.locale]['Are you sure to remove this row?'],
        accept: this.confirmDelete
      })
    },
    confirmDelete () {
      this.data.splice(this.activeIndex, 1)
    },
    validateErrorContainError (row) {
      if (row.errors && row.errors.error) {
        return true
      }
    },
    isExcel (file) {
      return /\.(xlsx|xls)$/i.test(file.name)
    },
    normalizeHeaderCell (value) {
      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ')
    },
    findColumnIndex (header, acceptedHeaders) {
      return header.findIndex(cell => acceptedHeaders.includes(cell))
    },
    getUploadRows (rows) {
      const skuHeaders = ['sku / product', 'sku/product', 'sku', 'product', 'product sku']
      const quantityHeaders = ['quantity', 'qty']
      const flagHeaders = ['flag', 'flags']

      for (let rowIndex = 0; rowIndex < Math.min(rows.length, 10); rowIndex++) {
        const header = (rows[rowIndex] || []).map(this.normalizeHeaderCell)
        const skuIndex = this.findColumnIndex(header, skuHeaders)
        const quantityIndex = this.findColumnIndex(header, quantityHeaders)
        const flagIndex = this.findColumnIndex(header, flagHeaders)

        if (skuIndex !== -1 && quantityIndex !== -1) {
          return rows
            .slice(rowIndex + 1)
            .filter(row => row.some(cell => cell !== null && cell !== ''))
            .map(row => ({
              sku: row[skuIndex] ? String(row[skuIndex]).trim() : '',
              quantity: row[quantityIndex] || '',
              flag: flagIndex !== -1 ? this.getFlagsFromCell(row[flagIndex]) : []
            }))
        }
      }

      return []
    },
    getFlagsFromCell (value) {
      return (value || '')
        .toString()
        .split(',')
        .map(item => this.normalizeHeaderCell(item))
        .map(value => this.flags.find(flag => this.normalizeHeaderCell(flag.name) === value))
        .filter(Boolean)
    },
    getFlagIds (flags) {
      return (flags || []).map(flag => flag.id)
    },
    getSubmitErrorText (error) {
      const data = error && error.response ? error.response.data : null
      if (!data) return this.$t('Something went wrong. Please try again.')
      if (typeof data === 'string') return data
      if (data.detail) return data.detail
      if (data.message) return data.message
      if (data.error) return typeof data.error === 'string' ? data.error : JSON.stringify(data.error)
      return JSON.stringify(data)
    },
    stringifyErrorValue (value) {
      if (Array.isArray(value)) return value.map(item => this.stringifyErrorValue(item)).join(', ')
      if (value && typeof value === 'object') {
        return Object.keys(value)
          .map(key => `${key}: ${this.stringifyErrorValue(value[key])}`)
          .join(', ')
      }
      return value ? value.toString() : ''
    },
    notifySubmitWarnings (messages) {
      const uniqueMessages = [...new Set(messages.filter(Boolean))]
      if (uniqueMessages.length === 0) return

      this.$vs.notify({
        color: 'warning',
        title: i18nData[this.$i18n.locale]['Warning'],
        text: uniqueMessages.join('\n'),
        position: 'top-center'
      })
    },
    getApiErrorMessages (error, rows) {
      const data = error && error.response ? error.response.data : null
      if (!data) return [this.$t('Something went wrong. Please try again.')]
      if (typeof data === 'string') return [data]
      if (data.detail || data.message || data.error) return [this.getSubmitErrorText(error)]

      if (Array.isArray(data.products)) {
        return data.products
          .map((productError, index) => {
            const row = rows[index]
            const rowNumber = this.data.indexOf(row) + 1
            const errorText = this.stringifyErrorValue(productError)
            return errorText ? `${this.$t('Row')} ${rowNumber}: ${errorText}` : ''
          })
          .filter(Boolean)
      }

      return [this.stringifyErrorValue(data)]
    },
    getMerchantID () {
      return this.merchant && this.merchant.id ? this.merchant.id : this.userMerchant.merchant
    },
    normalizeSku (sku) {
      return (sku || '').toString().trim().toLowerCase()
    },
    loadProductCatalog (searchVal = '') {
      return new Promise((resolve, reject) => {
        const merchantID = this.getMerchantID()
        if (!merchantID) {
          reject(new Error('Missing merchant id'))
          return
        }

        this.searchInProgress = true
        sendFulfillmentRequest(false, false, this, `api/v1/fc/products/?merchant=${merchantID}&limit=1000&search=${searchVal}${this.productsQueryParams}`, 'get', null, true,
          (response) => {
            this.allProductsList = response.data.results
            this.productCatalog = []
            this.allProductsList.forEach(element => {
              this.productCatalog.push(element)
            })
            this.allProductsList.map(item => {
              item.optionalLabel = `Name: ${item.name} . ${item.current_inventory_level} available`
            })
            this.searchedValue = searchVal
            this.searchInProgress = false
            resolve(this.allProductsList)
          },
          (error) => {
            this.searchInProgress = false
            reject(error)
          }
        )
      })
    },
    loadProductBySku (sku) {
      return this.loadProductCatalog(sku).then(products => {
        return products.find(product => this.normalizeSku(product.sku) === this.normalizeSku(sku))
      })
    },
    resolveRowProducts (rows) {
      const productBySku = {}
      const uniqueSkus = [...new Set(rows.map(row => row.sku).map(this.normalizeSku))]

      return Promise.all(uniqueSkus.map(sku => {
        return this.loadProductBySku(sku).then(product => {
          productBySku[sku] = product
        })
      })).then(() => {
        rows.forEach(row => {
          row.product = productBySku[this.normalizeSku(row.sku)]
        })
      })
    },
    setFlagDropdownPosition (dropdownList, component, position) {
      dropdownList.classList.add('stock-request-flag-dropdown')
      Object.assign(dropdownList.style, position)

      return () => dropdownList.classList.remove('stock-request-flag-dropdown')
    },
    uploadFile (file) {
      const fileDetail = file && file.data ? file : { id: '', data: file }
      const rawFile = fileDetail.data
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          color: 'warning',
          title: i18nData[this.$i18n.locale]['Warning'],
          text: this.$t('Only supports upload .xlsx, .xls suffix files'),
          position: 'top-center'
        })
        return false
      }
      let oldDataExistLength = 0
      for (let i = 0; this.data.length > i; i++) {
        if (this.data[i].sku !== '') oldDataExistLength = i
      }
      oldDataExistLength = (oldDataExistLength === 0 && this.data[0] && this.data[0].sku === '') || this.data[0] === undefined ? 0 : oldDataExistLength + 1
      const replacedFileId = this.replacedFile ? this.replacedFile.id : ''
      const replaceStartIndex = replacedFileId ? this.data.findIndex(row => row.fileUploadId === replacedFileId) : -1
      const startIndex = replaceStartIndex === -1 ? oldDataExistLength : replaceStartIndex

      readXlsxFile(rawFile).then((rows) => {
        const uploadRows = this.getUploadRows(rows)
        if (uploadRows.length > 0) {
          if (this.replacedFile) {
            for (let i = this.fileDetails.length - 1; i >= 0; --i) {
              if (this.fileDetails[i].id === replacedFileId) {
                this.fileDetails.splice(i, 1)
              }
            }
            this.isReplace = true
            this.removeItemsFromData(replacedFileId)
          }
          if (!this.fillManualPressed) {
            for (let index = 0; index < uploadRows.length; index++) {
              this.data.push(this.emptyRow())
            }
          } else {
            const extraRow = uploadRows.length - (this.data.length - startIndex)
            for (let index = 0; index < extraRow; index++) {
              this.data.push(this.emptyRow())
            }
          }
          uploadRows.forEach((row, index) => {
            this.$set(this.data, index + startIndex, {
              ...this.emptyRow(),
              sku: row.sku,
              quantity: row.quantity,
              flag: row.flag,
              fileName: rawFile.name,
              fileUploadId: fileDetail.id
            })
          })
        } else {
          this.$vs.notify({
            color: 'danger',
            title: i18nData[this.$i18n.locale]['Failed'],
            text: i18nData[this.$i18n.locale]['Wrong File!'],
            position: 'top-center'
          })
          this.$emit('deleteFile')
          this.$emit('replacedFile', '')
        }
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: i18nData[this.$i18n.locale]['Failed'],
          text: i18nData[this.$i18n.locale]['Wrong File!'],
          position: 'top-center'
        })
        this.$emit('deleteFile')
        this.$emit('replacedFile', '')
      })
    },
    removeItemsFromData (deletedFile = this.deletedFile) {
      for (let index = 0; index < this.data.length; index++) {
        if (this.data[index].fileUploadId === deletedFile) {
          this.$set(this.data, index, this.emptyRow())
        }
      }
      this.isReplace = false
      this.$emit('deletedFile', '')
      this.$emit('replacedFile', '')
    },
    async sendStockRequests () {
      const validRows = this.data.filter(row => row.sku && row.sku.toString().trim() !== '')
      const rowsToSend = validRows.filter(row => row.status !== 200)
      if (rowsToSend.length === 0) {
        this.$emit('submitFinished')
        return
      }

      let hasError = false
      rowsToSend.forEach(row => {
        row.errors = {}
        row.valid = false
        if (!row.sku || row.sku.toString().trim() === '') {
          row.errors.sku = true
          hasError = true
        }
        if (!row.quantity || Number(row.quantity) <= 0) {
          row.errors.quantity = true
          hasError = true
        }
      })
      if (hasError) {
        const validationMessages = []
        rowsToSend.forEach(row => {
          row.loadRow = false
          row.valid = !row.errors.sku && !row.errors.quantity
          const rowNumber = this.data.indexOf(row) + 1
          if (row.errors.sku) validationMessages.push(`${this.$t('Row')} ${rowNumber}: ${this.$t('SKU is required.')}`)
          if (row.errors.quantity) validationMessages.push(`${this.$t('Row')} ${rowNumber}: ${this.$t('Quantity must be greater than 0.')}`)
        })
        this.notifySubmitWarnings(validationMessages)
        this.$emit('submitFinished')
        return
      }

      rowsToSend.forEach(row => { row.loadRow = true })

      try {
        await this.resolveRowProducts(rowsToSend)
      } catch (error) {
        rowsToSend.forEach(row => { row.loadRow = false })
        this.notifySubmitWarnings([this.getSubmitErrorText(error)])
        this.$emit('submitFinished')
        return
      }

      const unknownSkuMessages = []
      const validationMessages = []
      rowsToSend.forEach(row => {
        if (!row.product) {
          row.errors.sku = true
          row.loadRow = false
          row.valid = false
          hasError = true
          unknownSkuMessages.push(`${this.$t('Row')} ${this.data.indexOf(row) + 1}: ${this.$t('Unknown SKU')} ${row.sku}`)
        } else if (this.isStockRecall && Number(row.quantity) > Number(row.product.current_inventory_level)) {
          row.errors.quantity = true
          row.loadRow = false
          row.valid = false
          hasError = true
          validationMessages.push(`${this.$t('Row')} ${this.data.indexOf(row) + 1}: ${this.$t('Recall quantity exceeds available inventory.')}`)
        } else {
          row.loadRow = false
          row.valid = true
        }
      })
      if (hasError) {
        this.notifySubmitWarnings([...unknownSkuMessages, ...validationMessages])
        this.$emit('submitFinished')
        return
      }

      rowsToSend.forEach(row => {
        row.valid = false
        row.loadRow = true
      })

      const merchantID = this.getMerchantID()
      const requestBody = {
        merchant: merchantID,
        fulfillment_center: 1,
        num_vehicles: 1,
        products: rowsToSend.map(row => {
          const product = {
            flags: this.getFlagIds(row.flag),
            product: row.product.id
          }
          product[this.quantityPayloadField] = Number(row.quantity)
          return product
        })
      }

      sendFulfillmentRequest(true, false, this, this.submitEndpoint, 'post', requestBody, true,
        () => {
          rowsToSend.forEach(row => {
            row.status = 200
            row.loadRow = false
          })
          this.$emit('data', this.data)
          this.$emit('submitSucceeded')
          this.$emit('submitFinished')
        },
        (error) => {
          rowsToSend.forEach(row => {
            row.status = error && error.response ? error.response.status : 400
            row.errors = { error: error && error.response ? error.response.data : {} }
            row.loadRow = false
          })
          this.notifySubmitWarnings(this.getApiErrorMessages(error, rowsToSend))
          this.$emit('data', this.data)
          this.$emit('submitFinished')
        }
      )
    }
  },
  components: {
    vSelect
  },
  created () {
    common.checkMerchantInLocalStorage(this)
  }
}
</script>

<style lang="scss">
.stock-request-switch-icon {
  position: relative;
  cursor: pointer;
  span:nth-child(2) {
    display: none;
    position: absolute !important;
    top: 8.5px;
    left: 8.5px;
  }
  &:hover {
    border-radius: 6px;
    background: rgba(226, 127, 131, 0.26) !important;
    span:nth-child(1) {
      display: none;
    }
    span:nth-child(2) {
      display: block;
    }
  }
}
.stock-request-animated-input {
  height: 35px;
  background: rgba(231, 231, 231, 0.81) !important;
  backdrop-filter: blur(7.5px);
  border-radius: 6px;
  padding: 6px;
}
.stock-request-valid-row {
  td:first-child {
    background: #E8F7EF !important;
  }
  input,
  .vs__dropdown-toggle {
    background: #E8F7EF !important;
    border-color: #70BE97 !important;
  }
}
.stock-request-flag-select.vs--open {
  z-index: 1000;
}
/*! rtl:begin:ignore */
.stock-request-flag-dropdown {
  z-index: 1001;
  border: none;
  box-shadow: 0px 4px 12px rgba(10, 50, 102, 0.18);
  overflow-x: hidden;
  right: auto !important;
  direction: ltr;
}
/*! rtl:end:ignore */
.stock-request-flag-dropdown .vs__dropdown-option {
  color: #0A3266;
  padding: 6px 10px;
  white-space: nowrap;
}
[dir=rtl] .stock-request-flag-dropdown .vs__dropdown-option {
  direction: rtl;
  text-align: right;
}
.stock-request-flag-dropdown .vs__dropdown-option--highlight,
.stock-request-flag-dropdown .vs__dropdown-option:hover {
  background: #1C5BFE !important;
  color: #FFFFFF !important;
}
.stock-request-flag-dropdown .vs__dropdown-option--selected {
  background: #EDF4FB;
  color: #1C5BFE;
}
@mixin background-gradient {
  background-image: linear-gradient(45deg, #0A326630 0px, rgba(229, 229, 229, 0.8) 40px, #0A326630 80px);
}
.line {
  margin-top: 4px;
  @include background-gradient;
  animation: shine-lines 1s infinite alternate;
}
@keyframes shine-lines {
  0% {background-position: 200px;}
  100% {background-position: -200px;}
}
</style>
